export default "__VITE_ASSET__BZOHKxwp__"